import VerifyEmail from 'features/otp/challenges/VerifyEmail/VerifyEmail';
import React from 'react';

export default function Page() {
  return <VerifyEmail />;
}
